<!--FLEX CONTAINER-->
<div class="flex-container" *ngIf="cumulativeData$ | async as cumulativeData; else loading">

  <!--UPDATE INFO-->
  <div class="flex-container__update-info">
    <p>
      Updated in {{cumulativeData.updated | date: 'short'}}
    </p>
  </div>
  <!--/UPDATE INFO-->

  <!--*******************
  *       CARDS
  ***********************-->
  <div class="flex-container__cards">

    <!--DEATH CARD-->
    <data-card
      mainTitle="Total Deaths"
      secondaryTitle="Per Million"
      [cumulativeData]="cumulativeData.deaths"
      [todayCumulativeData]="cumulativeData.todayDeaths"
      [perMillionCumulativeData]="cumulativeData.deathsPerOneMillion"
      [isRotatable]="true"
      cardTextColor="darkred"
    >
    </data-card>
    <!--/DEATH CARD-->

    <!--CASES CARD-->
    <data-card
      mainTitle="Total Confirmed Cases"
      secondaryTitle="Per Million"
      [cumulativeData]="cumulativeData.cases"
      [todayCumulativeData]="cumulativeData.todayCases"
      [perMillionCumulativeData]="cumulativeData.casesPerOneMillion"
      [isRotatable]="true"
      cardTextColor="lightcoral"
    >
    </data-card>
    <!--/CASES CARD-->

    <!--RECOVERED CARD-->
    <data-card
      mainTitle="Total Recovered"
      secondaryTitle="Per Million"
      [cumulativeData]="cumulativeData.recovered"
      [todayCumulativeData]="cumulativeData.todayRecovered"
      [perMillionCumulativeData]="cumulativeData.recoveredPerOneMillion"
      [isRotatable]="true"
      cardTextColor="seagreen"
    >
    </data-card>
    <!--/RECOVERED CARD-->

    <!--CRITICAL CARD-->
    <data-card
      mainTitle="Total Critical"
      secondaryTitle="Per Million"
      [cumulativeData]="cumulativeData.critical"
      [perMillionCumulativeData]="cumulativeData.criticalPerOneMillion"
      [isRotatable]="true"
      cardTextColor="royalblue"
    >
    </data-card>
    <!--/CRITICAL CARD-->

    <!-- TESTS CARD-->
    <data-card
      mainTitle="Total Tests"
      secondaryTitle="Per Million"
      [cumulativeData]="cumulativeData.tests"
      [todayCumulativeData]="cumulativeData.testsPerOneMillion"
      [isRotatable]="false"
      cardTextColor="darkcyan"
    >
    </data-card>
    <!--/TESTS CARD-->

    <!--ACTIVE CARD-->
    <data-card
      mainTitle="Total Active Cases"
      secondaryTitle="Per Million"
      [cumulativeData]="cumulativeData.active"
      [perMillionCumulativeData]="cumulativeData.activePerOneMillion"
      cardTextColor="#e0774b"
      [isRotatable]="true"
    >
    </data-card>
    <!--/ACTIVE CARD-->

    <!--MORTALITY RATE CARD-->
    <data-card
      mainTitle="Case Mortality Rate"
      [cumulativeData]="cumulativeData.deaths / cumulativeData.cases"
      isPercentage="true"
      cardTextColor="lightslategray"
      [isRotatable]="false"
    >
    </data-card>
    <!--/MORTALITY RATE CARD-->

    <!-- POPULATION CARD-->
    <data-card
      mainTitle="World Population"
      secondaryTitle="Affected Countries"
      [cumulativeData]="cumulativeData.population"
      cardTextColor=" #33983e"
      [isRotatable]="false"
    >
    </data-card>
    <!--/POPULATION CARD-->

  </div>

  <!--*******************
  *       MAP
  ***********************-->

  <div class="flex-container__map">
    <app-ol-map></app-ol-map>
  </div>

  <!--*******************
  *   Countries Table
  ***********************-->

  <div class="flex-container__countries-table">
    <mat-form-field appearance="outline">
      <mat-label>Search for a country...</mat-label>
      <input (keyup)="getSearchQuery($event)"
             matInput placeholder="eg. Greece...">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <countries-list *ngIf="sortedCountries$ | async as sortedCountries"
                    [dataSource]="sortedCountries">
    </countries-list>
  </div>

</div>
<ng-template #loading>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>


